import { useApolloClient } from "@vue/apollo-composable";
import { handleError } from "@/services/AlertService";
import { DeliveryMethods } from "@/models/basket/DeliveryMethods";
import Checkout from "../queries/Checkout.graphql";

// @param bookingId - The ID of the booking to checkout.
// @param fulfilmentType - The fulfilment type selected by the user.
// @param ipAddress - The IP address of the user.
// @param managementQuestionAnswers - The answers to the management questions. Only required for B2B users, set it to a blank array for B2C users.
// @param notify - Whether to notify the user (via email) of their order.
// @param paymentInput - The payment input object.
// @returns A promise that resolves to the checkout data or null if there was an error.
export function authenticatedCheckout(bookingId: string, fulfilmentType: DeliveryMethods, ipAddress: string, managementQuestionAnswers: any, notify: boolean, paymentInput: any) {
    const { client } = useApolloClient();
    return new Promise(async (resolve, reject) => {
        try {
            const input = {
                bookingId,
                fulfilmentType,
                ipAddress,
                notify,
                paymentInput,
            };

            // This can be used for an authenticated B2C user as well as B2B, so it's possible to have no management question answers.
            if (managementQuestionAnswers) {
                // @ts-ignore
                input.managementQuestionAnswers = managementQuestionAnswers;
            }

            const result = await client.query({
                query: Checkout,
                variables: input,
            });

            if (result.data.checkout) {
                resolve(result.data.checkout);
                return;
            }

            resolve(null);
            return;
        } catch (error) {
            console.error(error);
            handleError(error);
            reject(error);
        }
    });
}
